import { useEffect } from 'react'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export function useFeatureMobileAnimation() {
  useEffect(() => {
    const sections = gsap.utils.toArray('.feature-mobile-item')

    sections.forEach((section, index) => {
      const contentTimeline = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          scrub: true,
          start: '-=650 70%',
          end: 'bottom 70%',
          toggleActions: 'play none none none',
        },
      })

      if (index > 0) {
        contentTimeline.from(`.feature-mobile-item-${index + 1}`, {
          // 整包圖片一開始淡進，第一張不用
          opacity: 0,
          delay: 0.35,
        })
      }

      contentTimeline.to(`.feature-mobile-item-${index + 1}`, {
        // 整包圖片變透明
        opacity: 0.15,
        delay: index === 0 ? 0.8 : 0.1, // 第一張動畫時機不同
      })

      // 每個圖片各自的動畫
      if (index === 1) {
        contentTimeline.from(
          `#phone-url`,
          {
            opacity: 1,
          },
          '-=1',
        )
      } else if (index === 2) {
        contentTimeline
          .from(
            `#phone-network-middle`,
            {
              opacity: 0,
            },
            '-=1',
          )
          .from(
            `#phone-network-around`,
            {
              opacity: 0,
            },
            '-=0.9',
          )
      } else if (index === 3) {
        contentTimeline.from(
          `#phone-distribution`,
          {
            opacity: 0,
          },
          '-=1',
        )
      } else if (index === 4) {
        contentTimeline
          .from(
            `#phone-card-media`,
            {
              opacity: 0,
            },
            '-=1',
          )
          .from(
            `#phone-card-awards`,
            {
              opacity: 0,
            },
            '-=0.9',
          )
      }

      contentTimeline
        .to(`#feature-mobile-item-${index}`, {
          // 列表內容
          opacity: 0,
          delay: 0.3,
        })
        .to(`.feature-mobile-item-${index + 1}`, {
          // 圖片
          opacity: 0,
        })
    })

    const tl = gsap.timeline()

    tl.to('.fixed', {
      opacity: 1,
      scrollTrigger: {
        trigger: '.fixed',
        pin: true,
        start: 'top 88px',
        end: 'bottom +=700',
        pinSpacing: false,
      },
    })

    return () => {
      ScrollTrigger.getAll().forEach((t) => t.kill())
    }
  }, [])
}
